import { options } from "../util";
import { UserContext } from "../../../../../../context/UserContext";
import { FlowHandlersContext } from "../../../../Menu/FlowContainer";
import { Stack, Typography } from "@mui/material";
import { Field } from "formik";
import { FormContainer, NavButtons } from "../../../../Menu/Flow";
import employerFlowStyles from "../../styles";
import { styles } from "../../../../../../legacyComponents/componentsV2/FlowV2/Fields/util";
import { useContext, useState } from "react";

export default function ReimbursementMethod(props) {
  const { user, getEmployer } = useContext(UserContext);
  const flowHandlers = useContext(FlowHandlersContext);
  const { mode, exitUrl, step, formik, displayOnly } = props;
  const { touched, values, setFieldValue } = formik;
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
  const employer = getEmployer();
  const qualifiedBenefits = values?.qualifiedBenefits || [];
  let allowACH = true;
  if (qualifiedBenefits.SECTION_213D || qualifiedBenefits.QUALIFIED) {
    allowACH = false;
  }
  const reimbursementMethodOptions = allowACH
    ? options.reimbursementMethods
    : options.reimbursementMethodsNoACH;

  const isValid = reimbursementMethodOptions.some(
    (o) => o.value === values?.reimbursementMethod?.value,
  );
  const showError =
    (hasAttemptedSubmit || touched.reimbursementMethod) && !isValid;
  async function handleNext(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    setHasAttemptedSubmit(true);

    if (!isValid) {
      return false;
    }

    await formik.submitForm();

    if (flowHandlers?.onNext) {
      await flowHandlers.onNext(formik.values);
    }

    return false;
  }
  return (
    <Stack spacing="30px" height="100%">
      <FormContainer>
        <Typography variant="h2" sx={employerFlowStyles.h2}>
          Reimbursement Method
        </Typography>
        <Typography>Choose how reimbursements will be handled.</Typography>

        <Stack spacing={2} sx={{ marginTop: "20px" }}>
          {/* Reimbursement Method */}
          <Stack>
            <Field name="reimbursementMethod">
              {({ field }) => (
                <select
                  {...field}
                  value={values.reimbursementMethod?.value || ""}
                  onChange={(e) => {
                    field.onChange(e);
                    const selectedValue = e.target.value;
                    if (selectedValue === "") {
                      setFieldValue(
                        "reimbursementMethod",
                        options.nullOption(),
                      );
                      setFieldValue(
                        "reimbursementTiming",
                        options.nullOption(),
                      );
                      setFieldValue("reimbursementDay", 0);
                      return;
                    }
                    const selectedOption = options.reimbursementMethods.find(
                      (opt) => opt.value === selectedValue,
                    );
                    setFieldValue("reimbursementMethod", selectedOption);

                    // Always reset timing on a method change. MONTHLY is a
                    // member of both lists but means different things on each
                    // path, so a leftover value would carry over silently.
                    setFieldValue(
                      "reimbursementTiming",
                      options.nullOption(),
                    );
                    // The debit dates are fixed now, so the day is no longer
                    // the employer's to choose.
                    setFieldValue("reimbursementDay", 0);
                  }}
                  disabled={displayOnly}
                  style={{
                    ...styles.select(!field.value.value),
                    border: `1px solid ${showError ? "#dc2626" : "#ACBEE8"}`,
                  }}
                >
                  <option value="">Select reimbursement method</option>
                  {reimbursementMethodOptions?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.display || option.value}
                    </option>
                  ))}
                </select>
              )}
            </Field>
            {showError && (
              <div className="error-message-fields">
                Please select a reimbursement method
              </div>
            )}
            {values?.reimbursementMethod?.value === "OTHER" && (
              <Typography
                sx={{
                  marginTop: "20px",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: 1.6,
                  color: "#465578",
                }}
              >
                You reimburse employees directly. Salusion sends you
                reimbursement reports showing how much to pay each employee.
              </Typography>
            )}
            {values?.reimbursementMethod?.value === "SALUSION" && (
              <Typography
                sx={{
                  marginTop: "20px",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: 1.6,
                  color: "#465578",
                }}
              >
                Salusion withdraws funds for approved expenses from your
                company's bank account and deposits them directly into
                employees' bank accounts.
              </Typography>
            )}
          </Stack>
        </Stack>
      </FormContainer>

      <NavButtons
        mode={mode}
        enableSave={true}
        exitUrl={exitUrl}
        step={step}
        onNextStep={handleNext}
      />
    </Stack>
  );
}
